import { create } from "zustand";

interface ExtensionStore {
  shouldWiggle: boolean;
  setShouldWiggle: (value: boolean) => void;
}

export const useExtensionBannerStore = create<ExtensionStore>((set) => ({
  shouldWiggle: false,
  setShouldWiggle: (value) => set({ shouldWiggle: value }),
}));
